import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categorySelect"]
  static values = {
    departments: { type: Array, default: [] }
  }

  connect() {
    this.filterCategories()
  }

  toggleOrgField(event) {
    const orgField = document.getElementById("organization-field")
    if (!orgField) return

    if (event.target.value === "org_admin") {
      orgField.classList.remove("hidden")
    } else {
      orgField.classList.add("hidden")
    }
  }

  filterCategories() {
    if (!this.hasCategorySelectTarget || !this.departmentsValue.length) return

    // Get all selected organization IDs from membership selects
    const orgSelects = this.element.querySelectorAll("select[name*='[organization_id]']")
    const selectedOrgIds = new Set()
    orgSelects.forEach(select => {
      if (select.value) selectedOrgIds.add(parseInt(select.value))
    })

    const currentValue = this.categorySelectTarget.value
    const select = this.categorySelectTarget

    // Clear all options except the blank one
    while (select.options.length > 1) {
      select.remove(1)
    }

    // Filter departments by selected orgs
    let filtered = this.departmentsValue
    if (selectedOrgIds.size > 0) {
      filtered = filtered.filter(d => selectedOrgIds.has(d.org_id))
    }

    // Add filtered options
    filtered.forEach(d => {
      const option = document.createElement("option")
      option.value = d.name
      option.textContent = `${d.name} — ${d.org_name}`
      if (d.name === currentValue) option.selected = true
      select.appendChild(option)
    })
  }

  orgChanged() {
    this.filterCategories()
  }
}
